import React from "react";
import { useTranslate } from "lang/Translate";

//scss
import "./SubsidiariesChanger.scoped.scss";

const SubsidiariesChanger = () => {
	return (
		<div className="subsidiariesChanger">
			<div className="active">{useTranslate({ component: "SubsidiariesChanger", Tkey: "REGULAR" })}</div>
			<div className="locked">
				<i className="fas fa-lock" />
				{useTranslate({ component: "SubsidiariesChanger", Tkey: "CARGO" })}
			</div>
			<div className="locked">
				<i className="fas fa-lock" />
				{useTranslate({ component: "SubsidiariesChanger", Tkey: "REGIONAL" })}
			</div>
			<div className="locked">
				<i className="fas fa-lock" />
				{useTranslate({ component: "SubsidiariesChanger", Tkey: "CHARTER" })}
			</div>
			<div className="locked">
				<i className="fas fa-lock" />
				{useTranslate({ component: "SubsidiariesChanger", Tkey: "CHEAP" })}
			</div>
		</div>
	);
};

export default SubsidiariesChanger;
